import { render, staticRenderFns } from "./autoPurchase.vue?vue&type=template&id=c0c4e960&scoped=true&"
import script from "./autoPurchase.vue?vue&type=script&lang=js&"
export * from "./autoPurchase.vue?vue&type=script&lang=js&"
import style0 from "./autoPurchase.vue?vue&type=style&index=0&id=c0c4e960&lang=less&scoped=true&"
import style1 from "./autoPurchase.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c4e960",
  null
  
)

component.options.__file = "autoPurchase.vue"
export default component.exports